import React, {useState, useEffect, useLayoutEffect} from 'react'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { useNavigate, useLocation } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"
import AnnouncementData from '../../JSON/announcements.json'
import { jwtDecode } from "jwt-decode";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../Styles/AdminAnnouncementDetail.css'
import { addAnnouncement } from '../Controller/AnnouncementController';

const AdminAddAnnouncement= () => {

    const customTheme = (theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary: "#4caf50", // Adjust the primary color as needed
          primary75: "#1a4b11", // Adjust the primary light color as needed
        },
      });

    const navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [description, setDescription] = useState("");
    const [endDate, setEndDate] = useState(null);

    const [loading, setLoading] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [finishFlag, setFinishFlag] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [emptyTokenFlag, setEmptyTokenFlag] = useState(false);

    useEffect(() => {
        window.scrollTo(0,0);
    },[])

    useEffect(() => {
        if(!openSnackbar && emptyTokenFlag){
            localStorage.removeItem('authToken');
            navigate("/admin");
        }
    }, [openSnackbar && emptyTokenFlag])

    useEffect(() => {
        if(!openSnackbar && success){
            setSuccess(false);
            navigate('/admin-dashboard/announcements');
        }

    }, [success && openSnackbar]) 

    const handleMoveBack = () => {
        navigate('/admin-dashboard/announcements')
    }

    // const tokenChecker = () => {
    //     let token = localStorage.getItem('authToken');
    //     if (!token) {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token not found, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         setEmptyTokenFlag(true);   
    //     }

    //     let decodedToken = jwtDecode(token);

    //     if (decodedToken && decodedToken.exp * 1000 > Date.now()){
    //         return;
    //     } else {
    //         setSeveritySnackbar("error");
    //         setMessageSnackbar("Token has expired, please log in again!");
    //         setSnackbarDuration(3000);
    //         setOpenSnackbar(true);
    //         setEmptyTokenFlag(true);
    //     }
    // }

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
        //   handleGenerateReport(event);
        }
      };

    const getCurrentDate = () => {
        const currentDate = new Date();
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return currentDate.toLocaleDateString('en-CA', options);
    };

    const formatDate = (dateString) => {
        if(!dateString) return getCurrentDate();
        const date = new Date(dateString);
        const options = { year: 'numeric', month: 'short', day: '2-digit' };
        return date.toLocaleDateString('en-CA', options);
    }

    const minDate = new Date();

    const handleAddAnnouncement = async (e) => {
        e.preventDefault();

        if(!title || !description || !endDate) return;

        // tokenChecker();

        const adjustedEndDate = new Date(endDate);
        adjustedEndDate.setHours(12, 0, 0, 0);

        const announcement = {
            "title": title,
            "description": description,
            "endDate": adjustedEndDate
        }

        try{
            setLoading(true);

            const response = await addAnnouncement(announcement);

            const status = response.status;
         
            if (status === 200) {

                setSeveritySnackbar("success");
                setMessageSnackbar(response?.data?.message);
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(true);
                
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured, please try again");
                setSuccess(false);
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
        } finally{
            setLoading(false);
        }
    }


    return(
        <>
            <div className='admin-announcement-detail-container' style={{backgroundColor: Color.secondaryText, color: Color.thirdText}}>
                <div className='admin-announcement-detail-header-container'>
                    <h4 className='admin-announcement-detail-header new'>
                        New Announcement
                    </h4>
                </div>
                <form className='admin-announcement-detail-contents' onSubmit={handleAddAnnouncement}>
                    <div className='admin-announcement-detail-label-input-container'>
                        <label htmlFor='title' className='admin-announcement-detail-label'>
                            Title
                        </label>
                        <input 
                            type='text'
                            id='title'
                            className='admin-announcement-detail-input'
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        /> 
                    </div>
                    <div className='admin-announcement-detail-label-input-container'>
                        <label htmlFor='description' className='admin-announcement-detail-label'>
                            Description
                        </label>
                        <textarea
                            id='description'
                            className='admin-announcement-detail-input'
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={7}
                            required
                        /> 
                    </div>
                    <div className='admin-announcement-detail-label-input-container'>
                        <label htmlFor='end-date' className='admin-announcement-detail-label'>
                            End Date
                        </label>
                        <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            value={formatDate(endDate)}
                            selectsStart
                            minDate={minDate}
                            dateFormat="dd/MM/yyyy"
                            showTimeSelect={false}
                            className={`custom-datepicker admin-announcement-detail-input`}
                            calendarClassName="custom-calendar"
                            theme={customTheme}
                            onKeyPress={handleKeyPress}
                            id="end-date"
                            required
                        />
                    </div>

                    <div className='admin-announcement-detail-btn-container'>
                        <button className='admin-announcement-detail-cancel-btn' onClick={handleMoveBack}>
                            Cancel
                        </button>
                        <button className='admin-announcement-detail-save-btn' type='submit'>
                            Save
                        </button>
                    </div>
                </form>
                
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>

            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default AdminAddAnnouncement;